"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = function _default() {
  if (typeof navigator !== 'undefined') {
    return navigator.maxTouchPoints > 0;
  }
  return false;
};
exports["default"] = _default;